<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'TahsilatModal',
    props:[
        "data",
    ],
    data() {
        return {
            paymnet_type:0,
            form: {},
            submitted: false,
        };
    },
    watch:{
        data(props){
            this.form = {...props}
        }
    },
    methods: {
        createPayment( { target }){ 
            this.paymnet_type = target.value
            this.getBanks(target.value)
        },  

        getBanks(paymnet_type){
            let type= paymnet_type == 2 ? 'banka' : 'cek'
            this.$http.post(`safebank`,{ output:'only', type} )
                        .then((resp) => this.banks = resp.data)
        },

        handleSubmit(){
            this.$http.put('/members/kb_update', this.form)
            .then(resp => notify.success(resp.data.message))
        },

        close(){
            this.$parent.$bvModal.hide('tahsilat_modal')
        }
    },
};
</script>

<template>
<b-modal id="tahsilat_modal"  title="Tahsilat Ekle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label">Ödeme Türü</label>
            <div class="col">
                <select class="form-select" @change="createPayment($event)">
                    <option value="">Seçiniz</option>
                    <option value="1">Nakit</option>
                    <option value="2">Kredi Kartı</option>
                    <option value="4">Havale</option>
                    <option value="3">Çek</option>
                </select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 2 || paymnet_type == 3 || paymnet_type == 4">
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-if="paymnet_type == 2">POS Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else-if="paymnet_type == 4">Havale Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else>Çek Bankası</label>
            <div class="col">
            <select class="form-select" v-model="form.credit_card_bank" id="bank">
                <option :value="bank.id" v-for="bank in banks" :key="bank.id">{{ bank.title }} </option>
            </select>
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 2">
            <label class="col-sm-5 col-form-label col-form-label" for="interest">POS Faiz Oranı (%)</label>
            <div class="col">
                <input
                id="interest" 
                v-model="form.credit_card_interest"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_giver_name">Çek Sahibi</label>
            <div class="col">
                <input
                id="cheque_giver_name" 
                v-model="form.cheque_giver_name"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_number">Çek Numarası</label>
            <div class="col">
                <input
                id="cheque_number" 
                v-model="form.cheque_number"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_date">Çek Tarihi</label>
            <div class="col">
                <input
                id="cheque_date" 
                v-model="form.cheque_date"
                type="date"
                class="form-control"
                />
          </div>
        </div>
         <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama</label>
            <div class="col">
                <input
                id="explaine" 
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">Ödenen Ücret</label>
            <div class="col">
                <input
                id="amount" 
                v-model="form.amount"
                type="text"
                class="form-control"
                />
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Tahsilat Ekle
            </b-button>
        </div>
    </form>
</b-modal>
</template>